import { all, fork } from 'redux-saga/effects';
import { watchFetchCompany } from './sagas/addCompanySaga';
import { watchCompanyList } from './sagas/companyListSaga';

export function* rootSaga() {
  yield all([fork(watchFetchCompany), fork(watchCompanyList)]);
}
